const queue: Array<() => void> = []
let marked = false

export function onAuthenticatedInteractive (cb: () => void): void {
  if (marked) {
    cb()
    return
  }
  queue.push(cb)
}

export function markAuthenticatedInteractive (): void {
  marked = true
  const pending = queue.splice(0)
  for (const cb of pending) {
    cb()
  }
}

export function resetAuthenticatedInteractive (): void {
  marked = false
  queue.length = 0
}
